import { Outlet, RouteObject, createBrowserRouter, useRouteError } from 'react-router-dom';
import { BreadcrumbsProvider, useUser } from './hooks';
import SiteContainer from './SiteContainer';
import { ProtectedRoute } from './components';
import {
	BanReasons,
	BudgetsList,
	Dashboard,
	EmployeeAssistance,
	Employment,
	EmploymentDashboard,
	Employments,
	EmploymentUsers,
	EmploymentUser,
	EmploymentPayments,
	EmploymentAdjustmentTypes,
	EmploymentPayouts,
	EmploymentPayoutView,
	EventView,
	ExpensesList,
	ExpensesReport,
	EventsReport,
	ExpenseRejectReasonsList,
	ExpenseTypesList,
	ExpenseView,
	FormQuestion,
	FormsList,
	LoginResponse,
	MyEvents,
	PaymentMethodsList,
	PayoutsList,
	PayoutView,
	PendingExpenses,
	PromotersList,
	TicketsReport,
	TitlesList,
	UserAccounts,
	UserExpenses,
	UserNotifications,
	UserRequests,
	Users,
	UserView,
	WorkersList,
	WorkerView,
	BudgetsDetails,
	WarehousesList,
	InventoryTypesList,
	WarehouseView,
	InventoryItemView,
	RequestList,
	RequestView,
	ItemsList,
	ShipmentList,
	ShipmentView,
	ContractEdit,
	ContractsList,
	WorkerConfirmation,
	IssuesList,
	IssueEdit,
	IssueTypesList,
	WarehousesMap,
} from './screens';
import { SiteRoute } from './SiteClasses';
import { joinUrls } from './SiteUtil';
import UserAccess from './UserAccess';
import PromoterView from './screens/PromoterView';
import OperacionesSidebar from './sidebars/OperacionesSidebar';
import EventSidebar from './sidebars/EventSidebar';

import WarehouseSidebar from './sidebars/WarehouseSidebar';
import EmploymentSidebar from './sidebars/EmploymentSidebar';

var site_routes : SiteRoute[] = [{
	ignore: true,
	title: 'Operaciones',
	element: null,
	path: '/',
	sidebar: <OperacionesSidebar />,
	children: [{
		path: '/events',
		element: <Dashboard />,
		title: 'Dashboard',
		iconName: 'calendar',
		access: UserAccess.EVENTS.VIEW_EVENTS,
		children: [{
			path: '/:id/*',
			element: <EventView />,
			sidebar: <EventSidebar />,
			title: p=>`Evento: ${p.id}`,
			access: UserAccess.EVENTS.VIEW_EVENTS,
		}]
	}, {
		path: '/my-events',
		element: <MyEvents />,
		title: 'Mis Eventos',
		iconName: 'calendar-check'
	}, {
		path: '/issues',
		element: <IssuesList />,
		title: 'Tareas',
		iconName: 'tasks',
		access: UserAccess.ISSUES.VIEW_ISSUES,
		children: [{
			path: '/types',
			title: 'Tipos de Tareas',
			element: <IssueTypesList />,
			access: UserAccess.ISSUES.VIEW_ISSUE_TYPES,
		}, {
			path: '/:id',
			title: p=> (p.id === 'create' ? 'Nueva Tarea' : `Tarea: ${p.id}`),
			element: <IssueEdit />,
			access: UserAccess.ISSUES.VIEW_ISSUES,
		}]
	}, {
		path: '/items',
		element: <ItemsList />,
		title: 'Estado de Equipos',
		iconName: 'layer-group',
		access: UserAccess.INVENTORY.VIEW_INVENTORY,
	}, {
		path: '/warehouses',
		element: <WarehousesList />,
		title: 'Almacenes',
		iconName: 'warehouse',
		access: UserAccess.INVENTORY.VIEW_WAREHOUSES,
		children: [{
			path: '/:warehouseId',
			title: p=>`Almacén: ${p.warehouseId}`,
			element: <WarehouseView />,
			sidebar: <WarehouseSidebar />,
			children: [
				{
					path: '/inventory/type/:typeId',
					element: <WarehouseView />,
					title: p => `Inventario: ${p.typeId}`,
					children: [
						{
							path: '/item/:itemId',
							element: <InventoryItemView />,
							title: p => `Equipo: ${p.itemId}`,
						}
					]
				}
			]
		}]
	},{
		path: '/map-warehouses',
		title: 'Mapa de almacenes',
		iconName: 'map-location',
		element: <WarehousesMap />
	},{
		path: '/types',
		title: 'Tipos de inventario',
		iconName: 'boxes',
		element: <InventoryTypesList />,
		access: UserAccess.INVENTORY.VIEW_INVENTORY,
	}, {
		path: '/requests',
		title: 'Solicitudes',
		iconName: 'laptop-file',
		element: <RequestList />,
		access: UserAccess.INVENTORY.VIEW_INVENTORY_REQUESTS,
		children: [
			{
				path: '/:id',
				title: p=> (p.id === 'create' ? 'Nueva solicitud' : `Solicitud: ${p.id}`),
				element: <RequestView />,
			},
		]
	}, {
		path: '/shipments',
		title: 'Envíos',
		iconName: 'truck-fast',
		element: <ShipmentList />,
		access: UserAccess.INVENTORY.VIEW_INVENTORY_SHIPMENTS,
		children: [
			{
				path: '/:id',
				title: p => (p.id === 'create' ? 'Crear envío' : `Envío: ${p.id}`),
				element: <ShipmentView />,
			},
		]
	}, {
		path: '/item/:itemId',
		title: p => `Equipo: ${p.itemId}`,
		element: <InventoryItemView />
	}
	, {
		path: '/user/expenses',
		element: <UserExpenses />,
		title: 'Mis Gastos',
		iconName: 'money-bill'
	}, {
		path: '/user/notifications',
		element: <UserNotifications />,
		title: 'Mis Notificaciones',
		iconName: 'bell'
	}, {
		path: '/user/requests',
		element: <UserRequests />,
		title: 'Mis Solicitudes',
		iconName: 'laptop-file',
		access: UserAccess.INVENTORY.CREATE_INVENTORY_REQUESTS,
	}, {
		path: '/expenses',
		element: <ExpensesList />,
		title: 'Gastos',
		iconName: 'money-bill-wave',
		access: UserAccess.ACCOUNTING.VIEW_EXPENSES,
		children: [{
			path: '/pendings',
			title: 'Gastos Pendientes',
			element: <PendingExpenses />,
			access: UserAccess.ACCOUNTING.VIEW_EXPENSES,
		}, {
			path: '/:id',
			title: p=>`Gasto: ${p.id}`,
			element: <ExpenseView />,
			access: UserAccess.ACCOUNTING.VIEW_EXPENSES,
		}]
	}, {
		path: '/budgets',
		element: <BudgetsList />,
		title: 'Presupuestos',
		iconName: 'file-invoice-dollar',
		access: UserAccess.EVENTS.VIEW_BUDGET,
	}, {
		path: '/expense/types',
		element: <ExpenseTypesList />,
		title: 'Tipos de Gastos',
		iconName: 'tags',
		access: UserAccess.ACCOUNTING.EDIT_EXPENSE_TYPE,
	}, {
		path: '/adjustment-types',
		element: <EmploymentAdjustmentTypes />,
		title: 'Tipos de ajustes',
		iconName: 'tags',
		access: UserAccess.EMPLOYMENTS.CREATE_PAYOUT,
	}, {
		path: '/expense/reject-reasons',
		element: <ExpenseRejectReasonsList />,
		title: 'Razones de Rechazo',
		iconName: 'ban',
		access: UserAccess.ACCOUNTING.EDIT_REJECT_REASON,
	}, {
		path: '/expense/methods',
		element: <PaymentMethodsList />,
		title: 'Métodos de Pago',
		iconName: 'credit-card',
		access: UserAccess.EVENTS.CREATE_EXPENSE,
	}, {
		path: '/users',
		element: <Users />,
		title: 'Usuarios',
		iconName: 'users',
		access: UserAccess.USERS.VIEW_USERS,
		children: [{
			path: ':id',
			title: p=>`Usuario: ${p.id}`,
			element: <UserView />,
			access: UserAccess.USERS.VIEW_USERS,
		}]
	}, {
		path: '/accounts',
		element: <UserAccounts />,
		title: 'Cuentas bancarias'
	}, {
		path: '/forms',
		title: 'Formularios',
		element: <FormsList />,
		access: UserAccess.FORMS.VIEW_FORMS,
		children: [{
			path: '/:qid',
			title: p=>`Pregunta: ${p.qid}`,
			element: <FormQuestion />,
			access: UserAccess.FORMS.VIEW_FORMS,
		}]
	}, {
		path: '/workers',
		title: 'Trabajadores',
		element: <WorkersList />,
		access: UserAccess.WORKERS.VIEW_WORKERS,
		children: [{
			path: '/:wid',
			title: p=>`Trabajador: ${p.wid}`,
			element: <WorkerView />,
			access: UserAccess.WORKERS.VIEW_WORKERS,
		}]
	}, {
		path: '/reasons',
		element: <BanReasons />,
		title: 'Razones de Baneo',
		access: UserAccess.WORKERS.VIEW_BAN_REASONS,
	}, {
		path: '/titles',
		element: <TitlesList />,
		title: 'Puestos',
		access: UserAccess.WORKERS.VIEW_WORKERS_TITLES,
	}, {
		path: '/contract',
		element: <ContractsList />,
		title: 'Contratos',
		access: UserAccess.WORKERS.EDIT_WORKERS,
		children: [{
			path: '/:id',
			element: <ContractEdit />,
			title: p=>`Contrato: ${p.id}`,
			access: UserAccess.WORKERS.EDIT_WORKERS,
		}]
	}, {
		path: '/payouts',
		title: 'Nómina',
		element: <PayoutsList />,
		access: UserAccess.ACCOUNTING.PAID_PAYOUT,
		children: [{
			path: '/:pid',
			title: p=>`Liquidación: ${p.pid}`,
			element: <PayoutView />,
			access: UserAccess.ACCOUNTING.PAID_PAYOUT,
		}]
	}, {
		path: '/budgets/details',
		title: p=>`Presupuestos`,
		element: <BudgetsDetails />,
		access: UserAccess.EVENTS.VIEW_BUDGET,
	}, {
		path: '/promoters',
		title: 'Promotores',
		element: <PromotersList />,
		access: UserAccess.EVENTS.VIEW_PROMOTERS,
		children: [{
			path: '/:pid',
			title: p=>`Promotor: ${p.pid}`,
			element: <PromoterView />,
			access: UserAccess.EVENTS.VIEW_PROMOTERS,
		}]
	}, {
		path: '/employments',
		title: 'Empleos',
		element: <Employments />,
		access: UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS,
		children: [{
			path: '/assistance/:id',
			title: 'Asistencia de Empleado',
			element: <EmployeeAssistance />,
			access: UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS,
		}, {
			path: '/assistance',
			title: 'Asistencia de Empleado',
			element: <EmployeeAssistance />,
			access: UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS,
		}, {
			path: '/:id',
			title: p=>`Empleo: ${p.id}`,
			element: <Employment />,
			sidebar: <EmploymentSidebar />,
			access: UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS,
			children: [{
				ignore: true,
				path: '*',
				element: <Employment />,
				title: null,
				access: UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS,
			}]
		}]
	},{
		path: 'employees',
		title: 'Dashboard de Empleados',
		element: <EmploymentDashboard />,
		access: UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS,
		children: [{
			path: '/users',
			title: 'Empleados',
			element: <EmploymentUsers />,
			access: UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS,
			children: [{
				path: '/:id',
				title: p=>`Usuario: ${p.id}`,
				element: <EmploymentUser />,
				access: UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS,
			}]
		}, {
			path: '/payments',
			title: 'Pagos',
			element: <EmploymentPayments />,
			access: UserAccess.EMPLOYMENTS.VIEW_PAYMENTS,
		}, {
			path: '/payouts',
			title: 'Nómina',
			element: <EmploymentPayouts />,
			access: UserAccess.EMPLOYMENTS.VIEW_PAYOUTS,
			children: [{
				path: '/:id',
				title: p=>`Pago: ${p.id}`,
				element: <EmploymentPayoutView />,
				access: UserAccess.EMPLOYMENTS.VIEW_PAYOUTS,
			}]
		}]
	}, {
		path: '/report/tickets',
		title: 'Aforos',
		element: <TicketsReport />,
		iconName: 'ticket',
		access: UserAccess.REPORTS.VIEW_TICKETS_REPORT,
	}, {
		path: '/report/expense',
		title: 'Reporte de gastos',
		element: <ExpensesReport />,
		iconName: 'money-bill',
		access: UserAccess.REPORTS.VIEW_EXPENSES_REPORT,
	}, {
		path: '/report/events',
		title: 'Reporte de eventos',
		element: <EventsReport />,
		iconName: 'calendar',
		access: UserAccess.REPORTS.VIEW_EVENTS_REPORT,
	},]
}]


const SiteContainerContainer = (props: { outlet: any })=>{
	return <BreadcrumbsProvider routes={site_routes}>
		<SiteContainer outlet={props.outlet} />
	</BreadcrumbsProvider>
}

var getBrowserRoute = (parent: string, route: SiteRoute) : RouteObject[]=>{
	var r : RouteObject[] = [];
	var path = joinUrls(parent, route.path);
	var element = route.element;
	if(route.access !== undefined && element){
		element = <ProtectedRoute access={route.access}>{element as JSX.Element}</ProtectedRoute>;
	}
	r.push({
		path: path,
		element: element,
	})
	if(route.children){
		for(var c of route.children){
			r.push(...getBrowserRoute(path, c))
		}
	}
	return r;
}

var browser_routes : RouteObject[] = [];
for(var i of site_routes){
	browser_routes.push(...getBrowserRoute('/', i));
}

const RouterComponent = ()=>{
	var { user, hasAccess } = useUser();
	var ErrorElement = ()=>{
		const error = (useRouteError() as any);
		return <div>
			<div className="fr centered header" style={{ fontSize: 100 }}>
				{error.status}
				<div className="sub header" style={{ fontSize: 20 }}>
					{error.status===404 ? 'Página no encontrada' : (
						hasAccess(6000) ? error.message : 'Hubo un error inesperado'
					)}
				</div>
			</div>
		</div>
	}

	const Router = createBrowserRouter([{
		path: '/auth',
		element: <LoginResponse />
	}, {
		path: '/confirm/:token',
		element: <WorkerConfirmation />
	}, {
		path: '/',
		errorElement: <SiteContainerContainer outlet={<ErrorElement />} />,
		element: <SiteContainerContainer outlet={<Outlet />} />,
		children: [
			{ path: '/', element: <Dashboard /> },
			...browser_routes,
		]
	}], {
		future: {
			v7_relativeSplatPath: true,
			v7_fetcherPersist: true,
			v7_normalizeFormMethod: true,
			v7_partialHydration: true,
			v7_skipActionErrorRevalidation: true,
		}
	});

	return Router;
}

export default RouterComponent;
